import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import LoginMode from '../../Types/LoginMode';
import LoginChangePassword from './ui/LoginChangePassword';
import LoginForgotPassword from './ui/LoginForgotPassword';
import LoginForm from './ui/LoginForm';
import LoginSelectOrganization from './ui/LoginSelectOrganization';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';

const StyledLoginError = styled.div`
  ${text('medium')}
  color: ${getColor('alert')};
  margin-bottom: 1.6rem;
`;

const LoginContainer = () => {
  const { loginMode, error } = useTypedSelector((state) => state.login);

  return (
    <>
      {error && <StyledLoginError>{error}</StyledLoginError>}
      {loginMode == LoginMode.Login && <LoginForm />}
      {loginMode == LoginMode.SelectOrganization && <LoginSelectOrganization />}
      {loginMode == LoginMode.ChangePassword && <LoginChangePassword />}
      {loginMode == LoginMode.ForgotPassword && <LoginForgotPassword />}
    </>
  );
};

export default LoginContainer;
